import { render, staticRenderFns } from "./TrackingSidebar.vue?vue&type=template&id=025a5420&scoped=true&"
import script from "./TrackingSidebar.vue?vue&type=script&lang=js&"
export * from "./TrackingSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025a5420",
  null
  
)

export default component.exports